import queryString from 'query-string';

import * as dummyFacetsApiResponseJson from '../dev/dummyFacetsApiResponse.json';

class ApiHelper {
  /**
   * @param {string} path URL (minus query params)
   * @param {{ [k: string]: string }} params Query params
   * @returns {string}
   */
  static buildUrl(path, params = {}) {
    /** @type {string} */
    let url;
    if (typeof URL !== 'undefined' && typeof URLSearchParams !== 'undefined') {
      const urlObj = new URL(path);
      if (urlObj.searchParams instanceof Array) {
        Object.keys(params).forEach((key) => urlObj.searchParams.append(key, params[key]));
        url = urlObj.toString();
      } else {
        url = null;
      }
    }
    if (!url) {
      url = `${path}`;
      if (typeof params === 'object' && Object.keys(params).length > 0) {
        url = `${url}?${queryString.stringify(params)}`;
      }
    }
    return url;
  }

  /*
  TODO this function is broken.

  1. It should get the facets from a Search query (e.g. using the `params` that it defines) but instead it gets them from
    /v2/facets (i.e. the facets for EVERYTHING - we just want the facets for one provider)
  2. Given that it does get the facets from /v2/facets, it access data from the response incorrectly.

  So in conclusion, this will never return any facetActivities presently
  */
  static facets(apiKey, provider, cache) {
    if (cache) {
      // @ts-expect-error wth is window.facilityStorage? It's not defined anywhere
      if (typeof window.facilityStorage !== 'undefined') {
        // @ts-expect-error wth is window.facilityStorage? It's not defined anywhere
        const cachedFacets = window.facilityStorage.getItem(`facets.${provider}`);
        if (cachedFacets) {
          return Promise.resolve(JSON.parse(cachedFacets));
        }
      }
    }

    const url = this.buildUrl(`${process.env.REACT_APP_API_URL}facilities-api/v2/facets`);
    let facetsPromise;

    if ((process.env.REACT_APP_USE_DUMMY_FACETS || '').toLowerCase() === 'true') {
      facetsPromise = new Promise((resolve) => resolve(dummyFacetsApiResponseJson));
    } else {
      facetsPromise = fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'X-API-KEY': apiKey,
        },
        mode: 'cors',
      }).then((res) => res.json());
    }

    const params = {
      'geo[radial]': '51.5211,0.1166,1000',
      mode: 'discovery-geo',
      limit: 0,
    };
    if (provider) {
      params['integrationId'] = provider;
    }

    return facetsPromise
      .then((json) => {
        const { activity, location } = json['imin:facet']['imin:index'];
        const facets = {
          activities: activity['imin:item'],
          locations: location['imin:item'],
        };
        // @ts-expect-error wth is window.facilityStorage? It's not defined anywhere
        if (cache && typeof window.facilityStorage !== 'undefined') {
          // @ts-expect-error wth is window.facilityStorage? It's not defined anywhere
          window.facilityStorage.setItem(`facets.${provider}`, JSON.stringify(facets));
        }
        return facets;
      })
      .catch(() => {
        return {};
      });
  }

  /**
   * @param {string} apiKey
   * @param {string} location in the format "lat, lng, radius"
   * @param {string} [provider]
   * @param {string} [activity]
   * @param {string[]} [iminTag]
   * @param {string[]} [iminTagNot]
   */
  static facilities(apiKey, location, provider, activity, iminTag = [], iminTagNot = []) {
    const params = {
      'geo[radial]': location,
      mode: 'discovery-geo',
      limit: '50',
    };
    if (provider) {
      params['providerId'] = provider;
    }
    if (activity) {
      params['activityPrefLabel'] = activity;
    }
    if (iminTag.length > 0) {
      params['iminTag'] = iminTag;
    }
    if (iminTagNot.length > 0) {
      params['iminTag[not]'] = iminTagNot;
    }
    const url = this.buildUrl(
      `${process.env.REACT_APP_API_URL}facilities-api/v2/facility-uses`,
      params
    );
    return fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-API-KEY': apiKey,
      },
      mode: 'cors',
    })
      .then((res) => res.json())
      .catch(() => {
        return {
          'imin:item': [],
        };
      });
  }

  /**
   * @param {string} apiKey
   * @param {string} facilityUseId
   */
  static async facility(apiKey, facilityUseId) {
    const url = `${process.env.REACT_APP_API_URL}facilities-api/v2/facility-uses/${facilityUseId}`;
    try {
      const res = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'X-API-KEY': apiKey,
        },
        mode: 'cors',
      });
      const json = await res.json();
      return json;
    } catch {
      return [];
    }
  }
}

export default ApiHelper;
